import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './PhotoGallery-CVE.css';

import Image1 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.23.02.jpeg';
import Image2 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.24.48.jpeg';
import Image3 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.24.57.jpeg';
import Image4 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.25.46.jpeg';
import Image5 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.27.33.jpeg';
import Image6 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.27.45.jpeg';
import Image7 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.27.49.jpeg';
import Image8 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.02.jpeg';
import Image9 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.03.jpeg';
import Image10 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.04-1.jpeg';
import Image11 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.05-1.jpeg';
import Image12 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.05.jpeg';
import Image13 from '../../Assets/images/OutofSchoolProject/WhatsApp-Image-2019-06-03-at-12.28.07-1.jpeg';

const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8, Image9, Image10, Image11, Image12, Image13];

const PhotoGallery5 = () => {
  return (
    <div className="photo-gallery-container">
      <div className="photo-gallery">
        <Carousel autoPlay infiniteLoop showThumbs={false} showStatus={false} interval={4000} transitionTime={1000}>
          {images.map((image, index) => (
            <div key={index} className="carousel-slide">
              <img src={image} alt={`Image ${index + 1}`} className="gallery-image"/>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default PhotoGallery5;
